module.exports = __webpack_public_path__ + "static/img/adv_icon3.fe9410c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/adv_icon3.png
// module id = xy5n
// module chunks = 1